<template>
  <div class="live-selling mr-2" :class="{ highlight: isHighlight }">
    <v-btn color="primary" class="mx-1" outline @click="handleOpenDialog()"> FACEBOOK SHOP </v-btn>
    <a href="https://blog.zwiz.app/meta-live-selling/" target="blank">
      <i class="fas fa-question-circle" style="font-size: 16px"></i>
    </a>
    <v-dialog v-model="showModal" persistent scrollable max-width="1000px">
      <v-card class="signup-form">
        <v-card-text class="ma-0" style="height: 600px">
          <div class="live-selling__wrapper" style="align-items: flex-start">
            <v-btn
              v-for="(type, index) in productTypes"
              :key="`product-menta-${index}`"
              :outline="filter.type !== type.value"
              color="primary"
              small
              @click="onChangeType(type.value)"
            >
              {{ type.text }}
            </v-btn>
            <div class="ml-auto mt-2">
              <p class="text-xs-right mb-1 warning--text">
                {{ $t('live_meta.check_permission') }}
                <span>
                  <a
                    href="https://business.facebook.com/bizkit/shopping-on-messenger/onboarding-summary/${
                    this.selectedBot.facebook_page_id
                  }"
                    target="_blank"
                  >
                    Live Shopping
                  </a>
                </span>
              </p>
              <p class="text-xs-right mb-0 warning--text mx-auto" style="max-width: 300px">
                {{ $t('live_meta.register') }}
                <span>
                  <a href="https://airtable.com/appQgzurod2unO4m8/shrlqCHGWJUJbNxAn" target="blank">
                    Live Shopping
                  </a>
                </span>
              </p>
            </div>
          </div>
          <div class="live-selling__wrapper">
            <div>
              <span>{{ $t('live_meta.search_product_name') }}</span>
              <v-text-field
                v-model="filter.search"
                outline
                dense
                hide-details
                :placeholder="$t('live_meta.search_product_name')"
                class="default-input"
                style="max-width: 200px"
              ></v-text-field>
            </div>
            <div>
              <span>{{ $t('Category') }}</span>
              <v-select
                v-model="filter.category"
                :items="categoryLists"
                item-text="name"
                item-value="id"
                hide-details
                :placeholder="$t('Category')"
                outline
                :menu-props="{ 'offset-overflow': true, 'position-y': 0, 'offset-y': true }"
                single-line
                style="max-width: 200px"
              ></v-select>
            </div>
            <v-btn color="primary" @click="onSearch()">
              {{ $t('Search') }}
            </v-btn>
            <v-btn color="primary" outline @click="clearFilter()">
              {{ $t('Clear Search') }}
            </v-btn>
          </div>
          <div class="d-flex justify-space-between">
            <v-checkbox
              v-model="isCheckedAll"
              class="d-inline-block mt-0"
              color="primary"
              hide-details
              :label="$t('Select All')"
              @change="onCheckedAll"
            >
            </v-checkbox>
            <p class="mb-0 text-xs-right">
              {{ $t('live_meta.product_count_selected') }}
              <span style="font-size: 36px; font-weight: 500" class="primary--text">
                {{ productSelected.length }}
              </span>
            </p>
          </div>
          <div class="text-xs-center">
            <v-pagination
              v-if="products.length"
              v-model="pagination.page"
              :length="pagination.pageCount"
              class="mb-2"
              @input="handleChangePagination"
            ></v-pagination>
          </div>

          <template v-if="isLoading">
            <div
              style="
                min-height: 300px;
                height: 300px;
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              <SyncLoader :color="$vuetify.theme.primary" :size="'10px'"></SyncLoader>
            </div>
          </template>
          <template v-else>
            <div v-if="!products.length" class="live-selling__no-product">
              <h2 v-if="!products.length" class="grey--text text-xs-center">
                {{ $t('No product found') }}
              </h2>
            </div>
            <v-layout v-else row wrap>
              <v-flex
                v-for="(product, index) in products"
                :key="`product-meta-${index}`"
                xs12
                md3
                class="pa-2"
              >
                <product-meta class="mb-4" :value="product">
                  <template #check>
                    <div style="position: absolute; top: -6px; right: 6px">
                      <v-checkbox
                        class="live-selling__checkbox"
                        :input-value="valueCheckBox(product)"
                        size="medium"
                        color="white"
                        @change="onChangeChecked(product)"
                      ></v-checkbox>
                    </div>
                  </template>
                </product-meta>
              </v-flex>
            </v-layout>
          </template>

          <div class="text-xs-center">
            <v-pagination
              v-if="products.length"
              v-model="pagination.page"
              :length="pagination.pageCount"
              class="mb-2"
              @input="handleChangePagination"
            ></v-pagination>
          </div>

          <div v-if="filter.type === 'NO_SYNC'" class="my-2">
            <small
              style="font-size: 14px"
              class="warning--text"
              v-html="$t('live_meta.connect_meta_catalog_warning')"
            ></small>
          </div>

          <div class="mt-4" style="display: flex; justify-content: center">
            <v-btn color="primary" outline :disabled="isSubmitting" @click="onCancel">
              {{ $t('cancel') }}
            </v-btn>
            <v-btn
              color="primary"
              :disabled="!productSelected.length || isSubmitting"
              :loading="isSubmitting"
              @click="onSubmit"
            >
              {{ filter.type === 'SYNC' ? $t('live_meta.remove') : $t('live_meta.upload') }}
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ProductMeta from './ProductMeta.vue'
import api from '@/api'
import { mapGetters } from 'vuex'
import facebookShopApi from '@/api/facebook-shop'
import SyncLoader from 'vue-spinner/src/SyncLoader.vue'
import { PAGE_GROUP } from '@/constants/page.js'
export default {
  components: { ProductMeta, SyncLoader },
  props: {
    categories: {
      type: Array,
      default: () => []
    },
    isKetShop: {
      type: Boolean,
      default: () => false
    },
    isHighlight: {
      type: Boolean,
      default: () => false
    }
  },
  data: () => ({
    isLoading: false,
    isSubmitting: false,
    showModal: false,
    products: [],
    pagination: {
      page: 1,
      limit: 10,
      pageCount: 1,
      total: 0
    },
    filter: {
      type: 'NO_SYNC',
      search: '',
      category: 'all'
    },
    productSelected: [],
    isCheckedAll: false
  }),
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    }),
    productTypes() {
      return [
        {
          text: this.$t('live_meta.product_meta_no_sync'),
          value: 'NO_SYNC'
        },
        ...(!this.isThailandPostmart
          ? [
              {
                text: this.$t('live_meta.product_meta'),
                value: 'SYNC'
              }
            ]
          : [])
      ]
    },
    categoryLists() {
      let categories = []
      if (this.isThailandPostmart) {
        if (this.categories.length) {
          for (let i = 0; i < this.categories.length; i++) {
            const category = this.categories[i]
            categories.push({
              name: category.title || '',
              id: category.slug
            })
          }
        }
      } else {
        categories.push({
          name: this.$t('All'),
          id: 'all'
        })
        if (!this.isKetShop) {
          categories.push({
            name: this.$t('Sale'),
            id: 'product_on_sale'
          })

          categories.push({
            name: this.$t('almost sold out'),
            id: 'product_almost_out_of_stock'
          })
        }
        if (this.categories.length) {
          for (let i = 0; i < this.categories.length; i++) {
            const category = this.categories[i]
            categories.push({
              name: category.display_name
                ? `${category.display_name} (${category.name || ''})`
                : category.name || '',
              id: category.id
            })
          }
        }
      }
      return categories
    },
    isThailandPostmart() {
      return [PAGE_GROUP.THAILANDPOSTMART].includes(this.selectedBot.page_group)
    }
  },
  methods: {
    async getProductMeta() {
      try {
        if (this.isThailandPostmart) {
          const params = {
            slug: this.filter.category || 'all',
            pageid: this.selectedBot.pageid,
            per_page: this.pagination.limit,
            pages: this.pagination.page,
            search: this.filter.search
          }
          api.getProductBySlugThailandPostmart(params, (error, response) => {
            console.log(response)
            if (!error && response && response.responsecode === 200) {
              this.products = response.data
              this.pagination.total = response.total
              this.pagination.pageCount =
                this.pagination.total > 0
                  ? Math.ceil(this.pagination.total / this.pagination.limit)
                  : 1
            }
            const isCheckedAll = Boolean(
              this.products.length &&
                this.products.every((item) => this.productSelected.includes(item.sku))
            )
            this.isCheckedAll = isCheckedAll
            this.isLoading = false
          })
        } else {
          const params = {
            limit: this.pagination.limit,
            offset: (this.pagination.page - 1) * this.pagination.limit,
            ref_code: 'zwiz',
            product_name: this.filter.search,
            categoryid:
              this.filter.category && this.filter.category !== 'all' ? this.filter.category : null,
            pageid: this.selectedBot.pageid,
            in_facebook:
              this.filter.type === 'SYNC'
                ? true
                : this.filter.type === 'NO_SYNC'
                ? false
                : undefined
          }
          await api.getProducts(params, (error, response) => {
            if (!error && response && response.responsecode === 200) {
              this.products = response.productlist
              this.pagination.total = response.total_records
              this.pagination.pageCount =
                this.pagination.total > 0
                  ? Math.ceil(this.pagination.total / this.pagination.limit)
                  : 1
            }
            const isCheckedAll = Boolean(
              this.products.length &&
                this.products.every((item) => this.productSelected.includes(item.id))
            )
            this.isCheckedAll = isCheckedAll
            this.isLoading = false
          })
        }
      } catch (error) {
        console.log('error', error)
      }
    },

    async onSearch() {
      this.pagination.page = 1
      this.pagination.pageCount = 1
      this.pagination.total = 0
      this.isLoading = true

      await this.getProductMeta()
    },
    async clearFilter() {
      this.filter.search = ''
      this.filter.category = 'all'
      this.pagination.page = 1
      this.pagination.pageCount = 1
      this.pagination.total = 0
      this.isLoading = true

      await this.getProductMeta()
    },
    async handleOpenDialog() {
      if (!this.selectedBot.facebook_smc_catalog_id) {
        this.$router.push({
          path: `/${this.currentLang}/billing`,
          query: {
            tab: 'social-connect-management'
          }
        })
      } else {
        if (!this.products.length) {
          this.isLoading = true
          this.getProductMeta()
        }
        this.showModal = true
      }
    },
    handleCloseDialog() {
      this.showModal = false
    },
    async handleChangePagination(pageNumber) {
      this.isLoading = true
      this.pagination.page = pageNumber
      await this.getProductMeta()
    },
    async onChangeType(type) {
      this.filter.type = type
      this.pagination.page = 1
      this.pagination.total = 0
      this.pagination.pageCount = 1
      this.isLoading = true
      this.productSelected = []

      await this.getProductMeta()
    },
    onChangeChecked(product) {
      if (this.isThailandPostmart) {
        if (this.productSelected.includes(product.sku)) {
          this.productSelected = this.productSelected.filter((item) => item !== product.sku)
        } else {
          this.productSelected.push(product.sku)
        }
      } else {
        if (this.productSelected.includes(product.id)) {
          this.productSelected = this.productSelected.filter((item) => item !== product.id)
        } else {
          this.productSelected.push(product.id)
        }
      }
    },
    onCheckedAll(checked) {
      if (this.isLoading) return
      if (this.isThailandPostmart) {
        if (checked) {
          this.isCheckedAll = true
          this.productSelected = [...this.products.map((item) => item.sku), ...this.productSelected]
        } else {
          this.isCheckedAll = false
          this.productSelected = this.productSelected.filter(
            (item) => !this.products.map((item) => item.sku).includes(item)
          )
        }
      } else {
        if (checked) {
          this.isCheckedAll = true
          this.productSelected = [...this.products.map((item) => item.id), ...this.productSelected]
        } else {
          this.isCheckedAll = false
          this.productSelected = this.productSelected.filter(
            (item) => !this.products.map((item) => item.id).includes(item)
          )
        }
      }
    },
    onCancel() {
      this.productSelected = []
      this.showModal = false
    },
    async onSubmit() {
      if (this.filter.type === 'SYNC') {
        this.unSyncProduct()
      } else if (this.filter.type === 'NO_SYNC') {
        this.syncProduct()
      }
    },
    async syncProduct() {
      try {
        this.isSubmitting = true
        let payload = {
          page_id: this.selectedBot.pageid
        }
        if (this.isThailandPostmart) {
          payload = {
            ...payload,
            product_skus: this.productSelected.map((item) => item.toString())
          }
        } else {
          payload = {
            ...payload,
            product_ids: this.productSelected.map((item) => item.toString())
          }
        }
        const response = this.isThailandPostmart
          ? await facebookShopApi.syncProductTero({
              data: payload
            })
          : await facebookShopApi.syncProduct({
              data: payload
            })
        if (response && response.status === 200) {
          await this.$swal.fire({
            title: this.$t('Success'),
            html: this.$t('live_meta.connect_meta_catalog_warning'),
            type: 'success'
          })
          this.productSelected = []
          this.isLoading = true
          await this.getProductMeta()
        } else {
          await this.$swal.fire({
            title: this.$t('Error'),
            text: (response.data && response.data.message) || '',
            type: 'error'
          })
        }
      } catch (error) {
        await this.$swal.fire({
          title: this.$t('Error'),
          text: (error.response && error.response.data && error.response.data.message) || '',
          type: 'error'
        })
      } finally {
        this.isSubmitting = false
      }
    },
    async unSyncProduct() {
      try {
        this.isSubmitting = true
        const payload = {
          page_id: this.selectedBot.pageid,
          product_ids: this.productSelected.map((item) => item.toString())
        }
        const response = await facebookShopApi.unSyncProduct({
          data: payload
        })
        if (response && response.status === 200) {
          await this.$swal.fire({
            title: this.$t('Success'),
            type: 'success'
          })
          this.productSelected = []
          this.isLoading = true
          await this.getProductMeta()
        } else {
          await this.$swal.fire({
            title: this.$t('Error'),
            text: (response.data && response.data.message) || '',
            type: 'error'
          })
        }
      } catch (error) {
        await this.$swal.fire({
          title: this.$t('Error'),
          text: (error.response && error.response.data && error.response.data.message) || '',
          type: 'error'
        })
      } finally {
        this.isSubmitting = false
      }
    },
    valueCheckBox(product) {
      if (this.isThailandPostmart) {
        return this.productSelected.includes(product.sku)
      }
      return this.productSelected.includes(product.id)
    }
  }
}
</script>

<style lang="scss">
.live-selling__wrapper {
  display: flex;
  align-items: flex-end;
  column-gap: 4px;
  margin-bottom: 16px;
}

.live-selling__no-product {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 200px;
}

.highlight {
  position: relative;
  z-index: 2;
  left: 0;
  background-color: #fff !important;
  padding: 8px;
  border-radius: 10px;
  border: 1px solid var(--primary-color);
  margin-bottom: -10px !important;
  margin-right: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/components/LiveSelling.vue